<template>
  <div class="overall-bg">
    <b-container fluid="xl" class="form-master-bg py-3">
      <b-row>
        <b-col lg="12" cols="12" xl="12" xxl="12" md="12" sm="12">
          <Headerlayout class="intro" :headertext="$t('Master')" :contenttext="$t('Mastercontent')">
          </Headerlayout>
        </b-col>
      </b-row>

      <b-row class="intro">
        <b-col lg="8" cols="8">
          <p class="light-txt">
            {{ $t('showing') }}
            {{ totalmasterlength }}
            {{ $t('masters') }}
          </p>
        </b-col>
      </b-row>
      <b-row class="pt-2 px-3" v-if="!loading">
        <b-col lg="12" cols="12">
          <div class="master_div" v-for="item in filteredMenus">
            <!-- {{item}} -->
            <p class="master-heading">{{ $t(`${item["MenuPath"]}`) }}</p>

            <b-row>
              <b-col xxl="3" xl="4" lg="4" md="6" sm="6" cols="12" v-for="submenu in SubMenu(item['MenuId'])">
                <div class="mastercard" @click="GetMenuRights(submenu)">
                  <div class="img-class">
                    <img :src="submenu.Image" alt="Master" class="icon-size" />
                  </div>
                  <div class="s-content">
                    <p class="master-heading-name py-2">
                      {{ $t(`${submenu["Path"]}`) }}
                    </p>
                    <p class="content">{{ $t(`${submenu["Content"]}`) }}</p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col>
          <div class="master_div" v-for="item in 3">
            <Skeleton height=".75rem" width="15%" class="mb-3"></Skeleton>
            <b-row>
              <b-col xl="4" lg="4" md="6" sm="6" cols="12" v-for="item in 5">
                <div class="whitecardbg">
                  <div class="d-flex gap-2">
                    <Skeleton height="5rem" width="25%" class="mb-2"></Skeleton>
                    <div class="w-100 d-flex flex-column justify-content-evenly">
                      <Skeleton width="30%" height="0.5rem" class="mb-3"></Skeleton>
                      <Skeleton width="90%"></Skeleton>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";

import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import masterCard from "../../../../components/Masters/MasterMainCard.vue";
import Gridlisted from "../../../../components/Masters/MasterGridView.vue";
import { useI18n } from "vue-i18n";
import AutoComplete from "../../../../components/FormComponents/AutoComplete.vue";
import Service from "../../Service/MastersService";
import EntityMasterservice from "../../Service/EntityMasterService";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "primevue/usetoast";
const $t = (key: string) => {
  return key;
};
export default defineComponent({
  components: {
    Headerlayout,
    masterCard,
    Gridlisted,

    AutoComplete,
  },
  setup() {
    // const handlePopState = (event) => {
    //   history.pushState(null, document.title, location.href);
    // };
    // const pushInitialState = () => {
    //   history.pushState(null, document.title, location.href);
    // };

    debugger;
    let totalmasterlength = ref(0);
    const { t } = useI18n();
    const router = useRouter();
    const toast = useToast();
    let menuarray: any = ref([]);
    let filteredMenus: any = ref([]);
    let filteredSubMenuArray: any = ref([]);
    let MenuArrayByRole: any = ref([]);
    let loading = ref(false);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    onMounted(() => {
      debugger;
      localStorage.removeItem("EntityData");
      // pushInitialState();
      // pushInitialState();
      // window.addEventListener('popstate', handlePopState);
      LoadMenus();
    });
    onUnmounted(() => {
      //window.removeEventListener('popstate', handlePopState);
    });
    // async function GetRightsByRoleId() {
    //   debugger;
    //   loading.value = true;
    //   let ModuleId = 3;

    //   let GetRightsResponse = await EntityMasterservice.GetRightsByRoleId(
    //     rolesData.RoleId,
    //     ModuleId,
    //     usersData.OrganizationId
    //   );

    //   console.log("menubyrole", GetRightsResponse["result"]);
    //   MenuArrayByRole.value = GetRightsResponse["result"];

    //   LoadMenus();
    // }

    async function LoadMenus() {
      debugger;
      let response = await Service.GetMenus(
        1,
        rolesData.RoleId,
        usersData.OrganizationId
      );

      console.log("MenuListMasterInventory", response["result"]);

      menuarray.value = response["result"];

      const uniqueMenus = new Map();

      // Iterate over the array and add unique MenuId, MenuName, and MenuPath combinations to the map
      response["result"].forEach((item) => {
        const { MenuId, MenuName, MenuPath } = item;
        if (!uniqueMenus.has(MenuId)) {
          uniqueMenus.set(MenuId, { MenuName, MenuPath });
        }
      });
      console.log(totalmasterlength.value);
      let arr: any = [];
      // Convert the uniqueMenus map to an array with MenuId, MenuName, and MenuPath
      filteredMenus.value = Array.from(uniqueMenus, ([MenuId, { MenuName, MenuPath }]) => ({
        MenuId,
        MenuName,
        MenuPath,
      }));

      console.log("univalues", filteredMenus);
      loading.value = false;
    }

    // Sub Menu
    // function SubMenu(items) {
    //   console.log("allmenu", menuarray);

    //   // filteredSubMenuArray.value = menuarray.value.filter(
    //   //   (item) =>
    //   //     item["MenuId"] == items &&
    //   //     item["IsActive"] == true &&
    //   //     item["OperationName"] == "Read"
    //   // );

    //   filteredSubMenuArray.value = menuarray.value.filter(
    //     (item) => item["MenuId"] == items
    //   );
    //   console.log("filteredArray", filteredSubMenuArray.value);

    //   return filteredSubMenuArray.value;
    // }

    function SubMenu(items) {
      console.log("allmenu", menuarray.value); // Note the use of .value on menuarray
      totalmasterlength.value = menuarray.value.length;

      // const cachedResult = filteredSubMenuArray.value.find(
      //   (cachedItem) => cachedItem.items === items
      // );

      // if (cachedResult) {
      //   console.log("cached result found!");
      //   return cachedResult.submenu;
      // }

      // Filter the submenus based on MenuId
      const filteredSubmenu = menuarray.value.filter(
        (item) => item["MenuId"] == items
      );

      console.log("filteredArray", filteredSubmenu);

      //  filteredSubMenuArray.value.push({ items, submenu: filteredSubmenu });

      return filteredSubmenu;
    }

    async function GetMenuRights(Submenu) {
      debugger;

      let InstantEntityId = {
        EntityId: Submenu.EntityId,
      };
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      router.push({
        path: Submenu.FixedHref,
      });
    }

    const store = [
      {
        id: 1,
        img: "/src/assets/Img/icons/StoreMaster.svg",
        master: t("stores.StoreMaster.Master"),
        content: t("stores.StoreMaster.content"),
        routes: "/StoreMaster",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/roommaster.svg",
        master: t("stores.Room.Master"),
        content: t("stores.Room.content"),
        routes: "/RoomTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/rackmaster.svg",
        master: t("stores.Rack.Master"),
        content: t("stores.Rack.content"),
        routes: "/RackMaster",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/rowmaster.svg",
        master: t("stores.Row.Master"),
        content: t("stores.Row.content"),
        routes: "/Rowtableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/boxmaster.svg",
        master: t("stores.Box.Master"),
        content: t("stores.Box.content"),
        routes: "/BoxMaster",
      },
    ];
    const Tax = [
      {
        id: 1,
        img: "/src/assets/Img/icons/taxmaster.svg",
        master: t("Tax.TaxMaster.Master"),
        content: t("Tax.TaxMaster.content"),
        routes: "/TaxMasterTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/hsnmaster.svg",
        master: t("Tax.HSNaster.Master"),
        content: t("Tax.HSNaster.content"),
        routes: "/HSNMasterTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/sub-tax.svg",
        master: t("Tax.SubTaxMaster.Master"),
        content: t("Tax.SubTaxMaster.content"),
        routes: "/SubTaxMasterTableview",
      },
    ];
    const Items = [
      {
        id: 1,
        img: "/src/assets/Img/icons/itemmaster.svg",
        master: t("Items.ItemMaster.Master"),
        content: t("Items.ItemMaster.content"),
        routes: "/ItemMasterTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/unitmaster.svg",
        master: t("Items.UnitMaster.Master"),
        content: t("Items.UnitMaster.content"),
        routes: "/UnitMasters",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/packsizemaster.svg",
        master: t("Items.PackSizeMaster.Master"),
        content: t("Items.PackSizeMaster.content"),
        routes: "/PackSizeMaster",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/stockreasons.svg",
        master: t("Items.StockReasons.Master"),
        content: t("Items.StockReasons.content"),
        routes: "/StockReasons",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/unitmaster.svg",
        master: t("Items.UnitConversionMaster.Master"),
        content: t("Items.UnitConversionMaster.content"),
        routes: "/UnitConversion",
      },
    ];
    const ItemCategory = [
      {
        id: 1,
        img: "/src/assets/Img/icons/itemmaster.svg",
        master: t("ItemCategory.ItemCategoryMaster.Master"),
        content: t("ItemCategory.ItemCategoryMaster.content"),
        routes: "/CategoryTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/groupmaster.svg",
        master: t("ItemCategory.GroupMaster.Master"),
        content: t("ItemCategory.GroupMaster.content"),
        routes: "/groupTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/subgroupmaster.svg",
        master: t("ItemCategory.SubGroupMaster.Master"),
        content: t("ItemCategory.SubGroupMaster.content"),
        routes: "/subgroupTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/supplier-mapping.svg",
        master: t("ItemCategory.ItemCategorySupplierMapping.Master"),
        content: t("ItemCategory.ItemCategorySupplierMapping.content"),
        routes: "/ItemSupplierMappingTblview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/link-new-category.svg",
        master: t("ItemCategory.LinkNewCategoryandItemtostore.Master"),
        content: t("ItemCategory.LinkNewCategoryandItemtostore.content"),
        routes: "/ItemStoreMappingTblview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/Store Wise Item Mapping.svg",
        master: t("ItemCategory.StoreCategoryMapping.Master"),
        content: t("ItemCategory.StoreCategoryMapping.content"),
        routes: "/StoreCategoryMappingTblview",
      },
      // {
      //   id: 1,
      //   img: "/src/assets/Img/icons/rate-contract.svg",
      //   master: t("ItemCategory.RateContract.Master"),
      //   content: t("ItemCategory.RateContract.content"),
      //   routes: "/RateContractTableview",
      // },
    ];
    const Supppliers = [
      {
        id: 1,
        img: "/src/assets/Img/icons/suppliermaster.svg",
        master: t("Supppliers.SupppliersMaster.Master"),
        content: t("Supppliers.SupppliersMaster.content"),
        routes: "/SupplierMasterTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/paymentterms.svg",
        master: t("Supppliers.PaymentTerms.Master"),
        content: t("Supppliers.PaymentTerms.content"),
        routes: "/PaymentTermsTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/deliveryterms.svg",
        master: t("Supppliers.DeliveryTerms.Master"),
        content: t("Supppliers.DeliveryTerms.content"),
        routes: "/DeliveryTermsTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/deliverymode.svg",
        master: t("Supppliers.DeliveryMode.Master"),
        content: t("Supppliers.DeliveryMode.content"),
        routes: "/DeliveryModeTableview",
      },
      {
        id: 1,
        img: "/src/assets/Img/icons/otherterms.svg",
        master: t("Supppliers.OtherTerms.Master"),
        content: t("Supppliers.OtherTerms.content"),
        routes: "/OtherTermsTableview",
      },
    ];
    const Manufacturer = [
      {
        id: 1,
        img: "/src/assets/Img/icons/manufacturermaster.svg",
        master: t("Manufacturer.ManufacturerMaster.Master"),
        content: t("Manufacturer.ManufacturerMaster.content"),
        routes: "/ManufacturerMasterTableview",
      },
    ];
    const Pharmacy = [
      {
        id: 1,
        img: "/src/assets/Img/icons/genericmaster.svg",
        master: t("Pharmacy.GenericMaster.Master"),
        content: t("Pharmacy.GenericMaster.content"),
        routes: "/GenericMasterTableview",
      },
      // {
      //     id: 1,
      //     img: '/src/assets/Img/icons/usermaster.svg',
      //     master: t("Pharmacy.User.Master"),
      //     content: t("Pharmacy.User.content"),
      //     routes: '/UnitMasters'
      // },
    ];
    const valueRef = ref("");
    return {
      store,
      Items,
      Pharmacy,
      Manufacturer,
      Supppliers,
      Tax,
      ItemCategory,
      value: valueRef,
      options: computed(() => {
        return [
          ["Google", "@gmail.com"],
          ["Netease", "@163.com"],
          ["Tencent", "@qq.com"],
        ].map((emailInfo) => {
          return {
            type: "group",
            label: emailInfo[0],
            key: emailInfo[0],
            children: [valueRef.value.split("@")[0] + emailInfo[1]],
          };
        });
      }),

      filteredMenus,
      SubMenu,
      filteredSubMenuArray,
      GetMenuRights,
      MenuArrayByRole,
      totalmasterlength,
      loading,
    };
  },
});
</script>
